import React from "react"
import {BiArrowBack} from "react-icons/bi";
import {useHistory} from "react-router-dom";
import { isNotEmpty } from "../../../helpers/functions";
import {Link} from "react-router-dom";

interface IPageHeaderProps{
    title?:string,
    isBackBtn?: boolean,
    urlBackBtn?: string,
    isFirstBtn?: boolean,
    firstBtnTitle?: string,
    handlerFirstBtn?: any,
    children?: any
}

const PageHeader:React.FC<IPageHeaderProps> = ({title, isBackBtn=false, urlBackBtn='',isFirstBtn=false, firstBtnTitle: firstBtnTitle = '', handlerFirstBtn, children}) => {
    const history = useHistory()
    return(
        <div className={"flex justify-between items-center pb-4 border-b border-gray-200 mb-8"}>
            <div className={"flex justify-start items-center"}>
                <div className={"text-slate-500 text-2xl"}>{title}</div>
            </div>
            <div className={"flex flex-row-reverse justify-end items-center"}>
                {isBackBtn &&
                <Link to={isNotEmpty(urlBackBtn) ? urlBackBtn : "#"}>
                    <div className={"flex justify-center items-center cursor-pointer text-gray-400 hover:text-blue-400"}>
                        <span className={"ml-2"}>بازگشت</span>
                        <span><BiArrowBack /></span>
                    </div>
                </Link>
                }
                {isFirstBtn &&
                <div onClick={handlerFirstBtn} className={"text-primary border border-primary text-md ml-4 py-2 px-2 rounded-xl cursor-pointer transition duration-200 hover:bg-primary hover:text-white"}>
                    <span>{firstBtnTitle}</span>
                </div>
                }
                {children}
            </div>
        </div>
    )
}

export default PageHeader